import styled, { ITheme } from '../../../theme'

const Loader = styled.div`
  border-radius: 50%;
  width: 5em;
  height: 5em;
  margin: 60px auto;
  font-size: 10px;
  text-indent: -9999em;
  border-top: 0.5em solid
    ${(props: ITheme) => props.theme.colors.palette.emerald};
  border-right: 0.5em solid
    ${(props: ITheme) => props.theme.colors.palette.emerald};
  border-bottom: 0.5em solid
    ${(props: ITheme) => props.theme.colors.palette.emerald};
  border-left: 0.5em solid #ffffff;
  animation: load 1.1s infinite linear;
  &:after {
    border-radius: 50%;
    width: 5em;
    height: 5em;
  }

  @keyframes load {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default Loader
